import { ChargeTypePolicy } from "constants/charge/ChargeTypePolicy";
import { FSPCountingKeyPolicy } from "constants/company/FSPCountingKeyPolicy";
import { FSPCountingValuePolicy } from "constants/company/FSPCountingValuePolicy";
import { getDefaultBuConfig, getDefaultBuConfigElement } from "domain/repository/apiUtil";
import _ from "lodash";


export const FSPCountingDroOpts = (operatingUnit: string) => {
    const ETB = { [FSPCountingKeyPolicy.ETB]: FSPCountingValuePolicy.ETB };
    const ETB_ADD_1 = { [FSPCountingKeyPolicy.ETB_ADD_1]: FSPCountingValuePolicy.ETB_ADD_1 };
    const ETB_MINUS_1 = { [FSPCountingKeyPolicy.ETB_MINUS_1]: FSPCountingValuePolicy.ETB_MINUS_1 };
    const ETD = { [FSPCountingKeyPolicy.ETD]: FSPCountingValuePolicy.ETD };
    const ETD_ADD_1 = { [FSPCountingKeyPolicy.ETD_ADD_1]: FSPCountingValuePolicy.ETD_ADD_1 };
    const ETD_MINUS_1 = { [FSPCountingKeyPolicy.ETD_MINUS_1]: FSPCountingValuePolicy.ETD_MINUS_1 };
    const ATB_ADD_1 = { [FSPCountingKeyPolicy.ATB_ADD_1]: FSPCountingValuePolicy.ATB_ADD_1 };
    const DISCHARGING = { [FSPCountingKeyPolicy.DISCHARGE]: FSPCountingValuePolicy.DISCHARGING };
    const FIRST_DISCHARGING = { [FSPCountingKeyPolicy.FIRST_DISCHARGE]: FSPCountingValuePolicy.FIRST_DISCHARGING };
    const LAST_DISCHARGING = { [FSPCountingKeyPolicy.LAST_DISCHARGE]: FSPCountingValuePolicy.LAST_DISCHARGING };
    const DELIVERY_DATE = { [FSPCountingKeyPolicy.DEL_DATE]: FSPCountingValuePolicy.DELIVERY_DATE };
    const COS = { [FSPCountingKeyPolicy.COS_DATE]: FSPCountingValuePolicy.COS };
    const TO_COS = { [FSPCountingKeyPolicy.TO_COS_DATE]: FSPCountingValuePolicy.TO_COS };
    const LOADING = { [FSPCountingKeyPolicy.LOADING]: FSPCountingValuePolicy.LOADING };
    const FIRST_LOADING = { [FSPCountingKeyPolicy.FIRST_LOADING]: FSPCountingValuePolicy.FIRST_LOADING };
    const LAST_LOADING = { [FSPCountingKeyPolicy.LAST_LOADING]: FSPCountingValuePolicy.LAST_LOADING };
    const RECEIVE_DATE = { [FSPCountingKeyPolicy.RECEIVE_DATE]: FSPCountingValuePolicy.RECEIVE_DATE };
    const RECEIVE_DATE_ADD_1 = { [FSPCountingKeyPolicy.RECEIVE_DATE_ADD_1]: FSPCountingValuePolicy.RECEIVE_DATE_ADD_1 };
    const FIRST_LEG_ETB = { [FSPCountingKeyPolicy.FIRST_ETB]: FSPCountingValuePolicy.FIRST_LEG_ETB };
    const FIRST_LEG_ETB_ADD_1 = { [FSPCountingKeyPolicy.FIRST_ETB_ADD_1]: FSPCountingValuePolicy.FIRST_LEG_ETB_ADD_1 };
    const FIRST_LEG_ETB_MINUS_1 = { [FSPCountingKeyPolicy.FIRST_ETB_MINUS_1]: FSPCountingValuePolicy.FIRST_LEG_ETB_MINUS_1 };
    const FIRST_LEG_ETD = { [FSPCountingKeyPolicy.FIRST_ETD]: FSPCountingValuePolicy.FIRST_LEG_ETD };
    const FIRST_LEG_ETD_ADD_1 = { [FSPCountingKeyPolicy.FIRST_ETD_ADD_1]: FSPCountingValuePolicy.FIRST_LEG_ETD_ADD_1 };
    const FIRST_LEG_ETD_MINUS_1 = { [FSPCountingKeyPolicy.FIRST_ETD_MINUS_1]: FSPCountingValuePolicy.FIRST_LEG_ETD_MINUS_1 };
    const SECOND_LEG_ETB = { [FSPCountingKeyPolicy.SECOND_ETB]: FSPCountingValuePolicy.SECOND_LEG_ETB };
    const SECOND_LEG_ETB_ADD_1 = { [FSPCountingKeyPolicy.SECOND_ETB_ADD_1]: FSPCountingValuePolicy.SECOND_LEG_ETB_ADD_1 };
    const SECOND_LEG_ETB_MINUS_1 = { [FSPCountingKeyPolicy.SECOND_ETB_MINUS_1]: FSPCountingValuePolicy.SECOND_LEG_ETB_MINUS_1 };
    const SECOND_LEG_ETD = { [FSPCountingKeyPolicy.SECOND_ETD]: FSPCountingValuePolicy.SECOND_LEG_ETD };
    const SECOND_LEG_ETD_ADD_1 = { [FSPCountingKeyPolicy.SECOND_ETD_ADD_1]: FSPCountingValuePolicy.SECOND_LEG_ETD_ADD_1 };
    const SECOND_LEG_ETD_MINUS_1 = { [FSPCountingKeyPolicy.SECOND_ETD_MINUS_1]: FSPCountingValuePolicy.SECOND_LEG_ETD_MINUS_1 };
    const FIRST_LEG_DISCHARGING = { [FSPCountingKeyPolicy.DISCHARGE]: FSPCountingValuePolicy.FIRST_LEG_DISCHARGING };
    const FIRST_LEG_FIRST_DISCHARGING = { [FSPCountingKeyPolicy.FIRST_DISCHARGE]: FSPCountingValuePolicy.FIRST_LEG_FIRST_DISCHARGING };
    const FIRST_LEG_LAST_DISCHARGING = { [FSPCountingKeyPolicy.LAST_DISCHARGE]: FSPCountingValuePolicy.FIRST_LEG_LAST_DISCHARGING };
    const SECOND_LEG_LOADING = { [FSPCountingKeyPolicy.LOADING]: FSPCountingValuePolicy.SECOND_LEG_LOADING };
    const SECOND_LEG_FIRST_LOADING = { [FSPCountingKeyPolicy.FIRST_LOADING]: FSPCountingValuePolicy.SECOND_LEG_FIRST_LOADING };
    const SECOND_LEG_LAST_LOADING = { [FSPCountingKeyPolicy.LAST_LOADING]: FSPCountingValuePolicy.SECOND_LEG_LAST_LOADING };
    const GATE_IN = { [FSPCountingKeyPolicy.GATE_IN]: FSPCountingValuePolicy.GATE_IN };
    const GATE_OUT = { [FSPCountingKeyPolicy.GATE_OUT]: FSPCountingValuePolicy.GATE_OUT };
    const STORAGE_FROM_DATE = { [FSPCountingKeyPolicy.STORAGE_FROM_DATE]: FSPCountingValuePolicy.STORAGE_FROM_DATE };
    const STORAGE_TO_DATE = { [FSPCountingKeyPolicy.STORAGE_TO_DATE]: FSPCountingValuePolicy.STORAGE_TO_DATE };
    const GATE_CLOSING_TIME = { [FSPCountingKeyPolicy.GATE_CLOSING_TIME]: FSPCountingValuePolicy.GATE_CLOSING_TIME };
    const POWER_PLUG_ON = { [FSPCountingKeyPolicy.POWER_PLUG_ON]: FSPCountingValuePolicy.POWER_PLUG_ON };
    const POWER_PLUG_OFF = { [FSPCountingKeyPolicy.POWER_PLUG_OFF]: FSPCountingValuePolicy.POWER_PLUG_OFF };
    const ETA = { [FSPCountingKeyPolicy.ETA]: FSPCountingValuePolicy.ETA };
    const RECEIVAL_OPEN_DATE_MINUS_1 = { [FSPCountingKeyPolicy.RECEIVAL_OPEN_DATE_MINUS_1]: FSPCountingValuePolicy.RECEIVAL_OPEN_DATE_MINUS_1 };
    const STOCK_TRANSFER_DATE = { [FSPCountingKeyPolicy.STOCK_TRANSFER_DATE]: FSPCountingValuePolicy.STOCK_TRANSFER_DATE };
    const railEnable: boolean = getDefaultBuConfigElement<boolean>("REACT_APP_FIELD_ENABLE", "RAIL") || false;
    const isRailMaster: boolean = getDefaultBuConfig<boolean>('REACT_APP_RAIL_ENABLE') || false;

    const getFSPCountingFromByChargeType = (chargeType: string) => {
        let items: { [key: string]: string } = {};

        if (chargeType === ChargeTypePolicy.CHARGE_TYPE_ITM) {
            items = {
                ...ETB, ...ETB_ADD_1, ...ETB_MINUS_1,
                ...ETD, ...ETD_ADD_1, ...ETD_MINUS_1,
                ...DISCHARGING, ...FIRST_DISCHARGING, ...LAST_DISCHARGING,
                ...ATB_ADD_1, ...ETA
            };
        } else if (chargeType === ChargeTypePolicy.CHARGE_TYPE_OBS) {
            items = {
                ...RECEIVE_DATE, ...RECEIVE_DATE_ADD_1, ...GATE_IN
            };
        } else if (chargeType === ChargeTypePolicy.CHARGE_TYPE_TSS) {
            isRailMaster && railEnable ? items = {
                ...FIRST_LEG_ETB, ...FIRST_LEG_ETB_ADD_1, ...FIRST_LEG_ETB_MINUS_1,
                ...FIRST_LEG_ETD, ...FIRST_LEG_ETD_ADD_1, ...FIRST_LEG_ETD_MINUS_1,
                ...FIRST_LEG_DISCHARGING, ...FIRST_LEG_FIRST_DISCHARGING, ...FIRST_LEG_LAST_DISCHARGING, ...RECEIVE_DATE
            } : items = {
                ...FIRST_LEG_ETB, ...FIRST_LEG_ETB_ADD_1, ...FIRST_LEG_ETB_MINUS_1,
                ...FIRST_LEG_ETD, ...FIRST_LEG_ETD_ADD_1, ...FIRST_LEG_ETD_MINUS_1,
                ...FIRST_LEG_DISCHARGING, ...FIRST_LEG_FIRST_DISCHARGING, ...FIRST_LEG_LAST_DISCHARGING
            };
        } else if (chargeType === ChargeTypePolicy.CHARGE_TYPE_GS) {
            items = {
                ...DISCHARGING, ...FIRST_DISCHARGING, ...LAST_DISCHARGING,
                ...GATE_IN, ...COS, ...RECEIVE_DATE
            };
        } else if (chargeType === ChargeTypePolicy.CHARGE_TYPE_RFH) {
            items = {
                ...DISCHARGING, ...FIRST_DISCHARGING, ...LAST_DISCHARGING,
                ...RECEIVE_DATE, ...POWER_PLUG_ON
            };
        } else if (chargeType === ChargeTypePolicy.CHARGE_TYPE_DEL) {
            items = {
                ...STORAGE_FROM_DATE
            };
        } else if (chargeType === ChargeTypePolicy.CHARGE_TYPE_RAIL) {
            items = {
                ...STORAGE_FROM_DATE
            };
        } else if (chargeType === ChargeTypePolicy.CHARGE_TYPE_ITS) {
            items = {
                ...LAST_DISCHARGING, ...GATE_IN
            };
        }

        return [
            ...(_.map(
                _.toPairs(items), ([key, value]) => (
                    { dropdownLabel: value, tagLabel: key, value: value }
                )
            ) ?? [])
        ];
    }

    const getFSPCountingToByChargeType = (chargeType: string/*, operatingUnit: string*/) => {
        let items: { [key: string]: string } = {};

        if (chargeType === ChargeTypePolicy.CHARGE_TYPE_ITM) {
            items = {
                ...DELIVERY_DATE, ...GATE_OUT
            };
        } else if (chargeType === ChargeTypePolicy.CHARGE_TYPE_OBS) {
            items = {
                ...ETB, ...ETB_ADD_1, ...ETB_MINUS_1,
                ...ETD, ...ETD_ADD_1, ...ETD_MINUS_1,
                ...LOADING, ...FIRST_LOADING, ...LAST_LOADING,
                ...GATE_CLOSING_TIME, ...RECEIVAL_OPEN_DATE_MINUS_1, ...STOCK_TRANSFER_DATE
            };
        } else if (chargeType === ChargeTypePolicy.CHARGE_TYPE_TSS) {
            items = {
                ...SECOND_LEG_ETB, ...SECOND_LEG_ETB_ADD_1, ...SECOND_LEG_ETB_MINUS_1,
                ...SECOND_LEG_ETD, ...SECOND_LEG_ETD_ADD_1, ...SECOND_LEG_ETD_MINUS_1,
                ...SECOND_LEG_LOADING, ...SECOND_LEG_FIRST_LOADING, ...SECOND_LEG_LAST_LOADING
            };
        } else if (chargeType === ChargeTypePolicy.CHARGE_TYPE_GS) {
            operatingUnit !== "RSCT" && operatingUnit !== "AQCT" ?
                items = {
                    ...LOADING, ...FIRST_LOADING, ...LAST_LOADING,
                    ...GATE_OUT, ...TO_COS,
                } :
                items = {
                    ...LOADING, ...FIRST_LOADING, ...LAST_LOADING,
                    ...GATE_OUT, ...TO_COS,
                    ...DELIVERY_DATE
                };

        } else if (chargeType === ChargeTypePolicy.CHARGE_TYPE_RFH) {
            items = {
                ...LOADING, ...FIRST_LOADING, ...LAST_LOADING,
                ...GATE_OUT, ...POWER_PLUG_OFF
            };
        } else if (chargeType === ChargeTypePolicy.CHARGE_TYPE_DEL) {
            items = {
                ...STORAGE_TO_DATE
            };
        } else if (chargeType === ChargeTypePolicy.CHARGE_TYPE_RAIL) {
            items = {
                ...STORAGE_TO_DATE
            };
        } else if (chargeType === ChargeTypePolicy.CHARGE_TYPE_ITS) {
            items = {
                ...GATE_OUT, ...ETB
            };
        }

        return [
            ...(_.map(
                _.toPairs(items), ([key, value]) => (
                    { dropdownLabel: value, tagLabel: key, value: value }
                )
            ) ?? [])
        ];
    }

    const getFSPCountingFromByChgTypeAndSubChgType = (chargeType: string, subChargeType: string) => {
        let items: { [key: string]: string } = {};

        if (subChargeType === "COS") {
            items = {
                ...DISCHARGING, ...GATE_IN, ...COS, ...RECEIVE_DATE
            };
        } else if (subChargeType === "CSR") {
            items = {
                ...GATE_IN, ...RECEIVE_DATE
            };
        } else if (subChargeType === "EM") {
            items = {
                ...DISCHARGING, ...LAST_DISCHARGING, ...RECEIVE_DATE
            };
        } else if (subChargeType === "EC") {
            items = {
                ...DISCHARGING, ...LAST_DISCHARGING, ...RECEIVE_DATE
            };
        } else if (subChargeType === "EI") {
            items = {
                ...GATE_IN, ...RECEIVE_DATE
            };
        } else if (subChargeType === "ITM") {
            items = {
                ...ETB, ...ETB_ADD_1, ...ETB_MINUS_1,
                ...ETD, ...ETD_ADD_1, ...ETD_MINUS_1,
                ...DISCHARGING, ...FIRST_DISCHARGING, ...LAST_DISCHARGING
            };
        } else if (subChargeType === "INTERIM" && chargeType === ChargeTypePolicy.CHARGE_TYPE_ITM) {
            items = {
                ...ETB, ...ETB_ADD_1, ...ETB_MINUS_1,
                ...ETD, ...ETD_ADD_1, ...ETD_MINUS_1,
                ...DISCHARGING, ...FIRST_DISCHARGING, ...LAST_DISCHARGING
            };
        } else if (subChargeType === "INTERIM" && chargeType === ChargeTypePolicy.CHARGE_TYPE_GS) {
            items = {
                ...DISCHARGING, ...FIRST_DISCHARGING, ...LAST_DISCHARGING,
                ...GATE_IN, ...COS, ...RECEIVE_DATE
            };
        } else if (subChargeType === "CONT") {
            items = {
                ...DISCHARGING, ...FIRST_DISCHARGING, ...LAST_DISCHARGING,
                ...GATE_IN, ...COS, ...RECEIVE_DATE
            };
        } else if (subChargeType === "TSS") {
            items = {
                ...FIRST_LEG_ETB, ...FIRST_LEG_ETB_ADD_1, ...FIRST_LEG_ETB_MINUS_1,
                ...FIRST_LEG_ETD, ...FIRST_LEG_ETD_ADD_1, ...FIRST_LEG_ETD_MINUS_1,
                ...FIRST_LEG_DISCHARGING, ...FIRST_LEG_FIRST_DISCHARGING, ...FIRST_LEG_LAST_DISCHARGING
            };
        } else if (subChargeType === "OBS" || "NR" === subChargeType || "SR" === subChargeType) {
            items = {
                ...RECEIVE_DATE
            };
        } else if ("PCI" === subChargeType || "PCX" === subChargeType
            || "MONITORI" === subChargeType || "MONITORX" === subChargeType) {
            items = {
                ...DISCHARGING, ...FIRST_DISCHARGING, ...LAST_DISCHARGING,
                ...RECEIVE_DATE, ...POWER_PLUG_ON
            };
        } else if ("INB" === subChargeType) {
            items = {
                ...LAST_DISCHARGING
            };
        } else if ("OUB" === subChargeType) {
            items = {
                ...GATE_IN
            };
        }

        return [
            ...(_.map(
                _.toPairs(items), ([key, value]) => (
                    { dropdownLabel: value, tagLabel: key, value: value }
                )
            ) ?? [])
        ];
    }

    const getFSPCountingFromBySubChargeType = (subChargeType: string) => {
        let items: { [key: string]: string } = {};

        if (subChargeType === "COS") {
            items = {
                ...DISCHARGING, ...GATE_IN, ...COS, ...RECEIVE_DATE
            };
        } else if (subChargeType === "CSR") {
            items = {
                ...GATE_IN, ...RECEIVE_DATE
            };
        } else if (subChargeType === "EM") {
            items = {
                ...DISCHARGING, ...LAST_DISCHARGING, ...RECEIVE_DATE
            };
        } else if (subChargeType === "EC") {
            items = {
                ...DISCHARGING, ...LAST_DISCHARGING, ...RECEIVE_DATE
            };
        } else if (subChargeType === "EI") {
            items = {
                ...GATE_IN, ...RECEIVE_DATE
            };
        } else if (subChargeType === "PCI" || subChargeType === "PCX" || subChargeType === "FDC") {
            items = {
                ...DISCHARGING, ...FIRST_DISCHARGING, ...LAST_DISCHARGING,
                ...RECEIVE_DATE, ...POWER_PLUG_ON
            };
        } else if (subChargeType === "T1") {
            items = {
                ...POWER_PLUG_ON
            };
        } else if (subChargeType === "ITM" || subChargeType === "DEI") {
            items = {
                ...ETB, ...ETB_ADD_1, ...ETB_MINUS_1, ...ETD, ...ETD_ADD_1,
                ...ETD_MINUS_1, ...DISCHARGING, ...FIRST_DISCHARGING,
                ...LAST_DISCHARGING, ...ATB_ADD_1
            };
        } else if (subChargeType === "OBS" || subChargeType === "DEX") {
            items = {
                ...RECEIVE_DATE, ...RECEIVE_DATE_ADD_1
            };
        }

        return [
            ...(_.map(
                _.toPairs(items), ([key, value]) => (
                    { dropdownLabel: value, tagLabel: key, value: value }
                )
            ) ?? [])
        ];
    }

    const getFSPCountingToByChgTypeAndSubChgType = (chargeType: string, subChargeType: string) => {
        let items: { [key: string]: string } = {};

        if (subChargeType === "COS") {
            items = {
                ...TO_COS
            };
        } else if (subChargeType === "CSR") {
            items = {
                ...GATE_OUT
            };
        } else if (subChargeType === "EM") {
            items = {
                ...GATE_OUT
            };
        } else if (subChargeType === "EC") {
            items = {
                ...GATE_OUT, ...LOADING
            };
        } else if (subChargeType === "EI") {
            items = {
                ...GATE_OUT
            };
        } else if (subChargeType === "ITM") {
            items = {
                ...DELIVERY_DATE
            };
        } else if (subChargeType === "CONT") {
            items = {
                ...LOADING, ...FIRST_LOADING, ...LAST_LOADING,
                ...GATE_OUT, ...TO_COS
            };
        } else if (subChargeType === "TSS") {
            items = {
                ...SECOND_LEG_ETB, ...SECOND_LEG_ETB_ADD_1, ...SECOND_LEG_ETB_MINUS_1,
                ...SECOND_LEG_ETD, ...SECOND_LEG_ETD_ADD_1, ...SECOND_LEG_ETD_MINUS_1,
                ...SECOND_LEG_LOADING, ...SECOND_LEG_FIRST_LOADING, ...SECOND_LEG_LAST_LOADING
            };
        } else if (subChargeType === "OBS") {
            items = {
                ...ETB, ...ETB_ADD_1, ...ETB_MINUS_1,
                ...ETD, ...ETD_ADD_1, ...ETD_MINUS_1,
                ...LOADING, ...FIRST_LOADING, ...LAST_LOADING,
                ...GATE_CLOSING_TIME
            };
        } else if (subChargeType === "INTERIM" && chargeType === ChargeTypePolicy.CHARGE_TYPE_ITM) {
            items = {
                ...DELIVERY_DATE
            };
        } else if (subChargeType === "INTERIM" && chargeType === ChargeTypePolicy.CHARGE_TYPE_GS) {
            items = {
                ...LOADING, ...FIRST_LOADING, ...LAST_LOADING,
                ...GATE_OUT, ...TO_COS
            };
        } else if ("PCI" === subChargeType || "PCX" === subChargeType
            || "MONITORI" === subChargeType || "MONITORX" === subChargeType) {
            items = {
                ...LOADING, ...FIRST_LOADING, ...LAST_LOADING,
                ...GATE_OUT, ...POWER_PLUG_OFF
            }
        } else if ("NR" === subChargeType) {
            items = {
                ...ETB, ...ETD,
                ...LOADING, ...FIRST_LOADING, ...LAST_LOADING,
                ...GATE_CLOSING_TIME, ...RECEIVAL_OPEN_DATE_MINUS_1
            }
        } else if ("SR" === subChargeType) {
            items = {
                ...ETB, ...ETD,
                ...LOADING, ...FIRST_LOADING, ...LAST_LOADING,
                ...GATE_CLOSING_TIME, ...RECEIVAL_OPEN_DATE_MINUS_1,
                ...STOCK_TRANSFER_DATE
            }
        } else if ("INB" === subChargeType) {
            items = {
                ...GATE_OUT
            }
        } else if ("OUB" === subChargeType) {
            items = {
                ...ETB
            }
        }

        return [
            ...(_.map(
                _.toPairs(items), ([key, value]) => (
                    { dropdownLabel: value, tagLabel: key, value: value }
                )
            ) ?? [])
        ];
    }

    const getFSPCountingToBySubChargeType = (subChargeType: string) => {
        let items: { [key: string]: string } = {};

        if (subChargeType === "COS") {
            items = {
                ...TO_COS
            };
        } else if (subChargeType === "CSR") {
            items = {
                ...GATE_OUT
            };
        } else if (subChargeType === "EM") {
            items = {
                ...GATE_OUT
            };
        } else if (subChargeType === "EC") {
            items = {
                ...GATE_OUT
            };
        } else if (subChargeType === "EI") {
            items = {
                ...GATE_OUT
            };
        } else if (subChargeType === "PCI" || subChargeType === "PCX" || subChargeType === "FDC") {
            items = {
                ...LOADING, ...FIRST_LOADING, ...LAST_LOADING, ...GATE_OUT,
                ...POWER_PLUG_OFF
            };
        } else if (subChargeType === "T1") {
            items = {
                ...POWER_PLUG_OFF
            };
        } else if (subChargeType === "ITM" || subChargeType === "DEI") {
            items = {
                ...DELIVERY_DATE
            };
        } else if (subChargeType === "OBS" || subChargeType === "DEX") {
            items = {
                ...ETB, ...ETB_ADD_1, ...ETB_MINUS_1,
                ...ETD, ...ETD_ADD_1, ...ETD_MINUS_1,
                ...LOADING, ...FIRST_LOADING, ...LAST_LOADING,
                ...GATE_CLOSING_TIME
            };
        }

        return [
            ...(_.map(
                _.toPairs(items), ([key, value]) => (
                    { dropdownLabel: value, tagLabel: key, value: value }
                )
            ) ?? [])
        ];
    }

    const getFromValueByKey = (chargeType: string, key: string) => {
        const tempDroOpts = getFSPCountingFromByChargeType(chargeType);

        return tempDroOpts?.find(item => item.tagLabel === key)?.value ?? "";
    }

    const getFromKeyByValue = (chargeType: string, value: string) => {
        const tempDroOpts = getFSPCountingFromByChargeType(chargeType);

        return tempDroOpts?.find(item => item.value === value)?.tagLabel ?? "";
    }

    const getToValueByKey = (chargeType: string, key: string/*, operatingUnit: string*/) => {
        const tempDroOpts = getFSPCountingToByChargeType(chargeType/*, operatingUnit*/);

        return tempDroOpts?.find(item => item.tagLabel === key)?.value ?? "";
    }

    const getToKeyByValue = (chargeType: string, value: string/*, operatingUnit: string*/) => {
        const tempDroOpts = getFSPCountingToByChargeType(chargeType/*, operatingUnit*/);

        return tempDroOpts?.find(item => item.value === value)?.tagLabel ?? "";
    }

    return {
        getFSPCountingFromByChargeType,
        getFSPCountingToByChargeType,
        getFSPCountingFromByChgTypeAndSubChgType,
        getFSPCountingFromBySubChargeType,
        getFSPCountingToByChgTypeAndSubChgType,
        getFSPCountingToBySubChargeType,
        getFromValueByKey,
        getFromKeyByValue,
        getToValueByKey,
        getToKeyByValue
    }
}